module.exports = __webpack_public_path__ + "static/img/SketchPng59d3405d541156cc45c9bb79be3b9b757c4c8bb544bac8aadc6e4f3a37d1810d.b100c595.png";